jQuery(document).ready(function ($) {
  const el = document.querySelector(".header");
  if (el) {
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(el);
  }

  var viewport = document.documentElement.clientWidth;

  $('a[href="#"]').click(function (e) {
    e.preventDefault();
  });

  $("a.newTab, .newTab > a").each(function (index, el) {
    $(this).attr("target", "_blank");
  });

  $(".nav-menu").on("click", function (e) {
    e.preventDefault();
    const isActive = !$(this).hasClass("active");
    $(this).toggleClass("active").attr("aria-expanded", isActive);
    $(".nav-right").toggleClass("active").attr("aria-expanded", isActive);
    $("body").toggleClass("u-noScroll");
  });

  $(".nav-sublinksToggle").click(function (e) {
    e.preventDefault();

    $(this).toggleClass("active");
    $(this).siblings(".sublinks").toggleClass("active");
  });

  var link = document.querySelector(".skipNavigation-link");

  if (link) {
    link.addEventListener("focus", function () {
      link.parentElement.classList.add("focus");
    });
    link.addEventListener("blur", function () {
      link.parentElement.classList.remove("focus");
    });
  }

  // Desktop Nav
  $(".nav-links .nav-link.has-sublinks > a").on("click", function (e) {
    e.preventDefault();
    const $parentLink = $(this).parent();
    const wasOpen = $parentLink.hasClass("is-open");

    // Close all sublinks first
    $(".nav-links .nav-link.has-sublinks").removeClass("is-open");
    $(
      ".nav-links .nav-link.has-sublinks > a, .nav-links .nav-link.has-sublinks .sublinks"
    )
      .attr("aria-expanded", "false")
      .attr("aria-hidden", "true");

    // If the clicked item wasn't open before, open it
    if (!wasOpen) {
      $(this).attr("aria-expanded", "true");
      $(this)
        .siblings(".sublinks")
        .attr("aria-expanded", "true")
        .attr("aria-hidden", "false");
      $parentLink.addClass("is-open");
    }
  });

  // Close when clicking outside of the subnav
  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".sublinks").length &&
      !$(e.target).closest(".nav-link.has-sublinks a").length
    ) {
      $(".nav-links .nav-link.has-sublinks").removeClass("is-open");
    }
  });
});
